import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../../services/login.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  userRole: string = '';
  isProjectsHomePage: boolean = false;
  isDashboardHomePage: boolean = false;
  isDashboardReferrerHomePage: boolean = false;

  constructor ( public loginService: LoginService ) { 
  }

  ngOnInit ( ) {
    this.userRole = this.loginService.userInfo.role;
    // this.isProjectsHomePage = this.userRole == 'sales';
    this.isDashboardHomePage = this.userRole == 'admin';// || this.userRole == 'manager';
    // this.isDashboardHomePage = this.userRole == 'admin' || this.userRole == 'manager';
    this.isDashboardReferrerHomePage = (this.userRole == 'referrer' || this.userRole == 'sales' || this.userRole == 'manager');
  }


}



// WEBPACK FOOTER //
// /root/anvel/angular/app/components/defaults/home/home.component.ts